import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import AuthLayout, { authStyles as s } from './components/AuthLayout';

const ERROR_MSG = {
  invalid_or_expired_token: '링크가 만료되었거나 유효하지 않습니다.',
  password_too_short: '비밀번호는 최소 8자 이상이어야 합니다.',
  missing_fields: '모든 필드를 입력해주세요.',
};

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) return setError('비밀번호가 일치하지 않습니다.');
    if (password.length < 8) return setError(ERROR_MSG.password_too_short);
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/password-reset/confirm', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(ERROR_MSG[data.error] || '재설정에 실패했습니다.');
        return;
      }
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } finally {
      setSubmitting(false);
    }
  }

  if (!token) {
    return (
      <AuthLayout title="Invalid link">
        <p className={s.error} style={{ textAlign: 'center' }}>유효한 재설정 링크가 아닙니다.</p>
        <div className={s.forgot}><Link to="/forgot-password">다시 요청하기</Link></div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Set new password">
      {done ? (
        <p className={s.success}>비밀번호가 변경되었습니다. 로그인 페이지로 이동합니다...</p>
      ) : (
        <form onSubmit={onSubmit}>
          <div className={s.field}>
            <label className={s.label}>New Password (min 8 chars)</label>
            <input className={s.input} type="password" placeholder="New Password" required
              value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <div className={s.field}>
            <label className={s.label}>Confirm Password</label>
            <input className={s.input} type="password" placeholder="Confirm Password" required
              value={confirm} onChange={e => setConfirm(e.target.value)} />
          </div>
          {error && <p className={s.error}>{error}</p>}
          <button className={s.primary} type="submit" disabled={submitting}>
            {submitting ? '변경 중...' : '비밀번호 변경'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
